export default __webpack_public_path__ + "static/media/future-leaders.65404a00.jpg";